import { IconButton } from "@mui/material";
import styled from "styled-components";
import { css } from "styled-components";

interface IBoxButtonCartProps {
	$isColumnGrid: boolean;
}
export const BoxButtonCart = styled(IconButton)<IBoxButtonCartProps>`
	&&& {
		${({ $isColumnGrid }) =>
			$isColumnGrid &&
			css`
				position: absolute !important;
				right: 0 !important;
				bottom: 0 !important;
			`};

		&:disabled {
			color: rgb(0 0 0 / 30%);
		}
	}
`;
